export const issues = state => {
    return state.issues;
};
